import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'

export function useConnector(provider: GraphQL.Providers) {
  const { data: connectorData, refetch } = useSuspenseQuery(
    AdminAPI.integration.GET_CONNECTOR,
    {
      variables: {
        provider
      },
      errorPolicy: 'all'
    }
  )

  return {
    connector: getFragment(
      SharedAPI.integration.CONNECTOR_FRAGMENT,
      connectorData?.getIntegrationConnector
    ),
    refetch
  }
}
